<template lang="pug">
  #app
    BlockLandscape(v-if="blockLandscape")
    transition(@enter="enterLoading")
      Loading(v-if="init")
    Menu
    Home(:home="home")
    Map
    Video
    Share
    Infographic
    Footer

</template>

<script>
import { gsap } from 'gsap'
import Loading from './components/Loading'
import Menu from './components/Menu'
import Home from './components/Home.vue'
import Map from './components/Map.vue'
import Video from './components/Video.vue'
import Share from './components/Share.vue'
import Infographic from './components/Infographic.vue'
import Footer from './components/Footer.vue'
import BlockLandscape from './components/Landscape.vue'
import isMobile from 'mobile-device-detect'



export default {
  name: 'App',
  data(){
		return {
			home:false,
			loading:false,
			init:true,
      blockLandscape: false
		}
	},
	beforeMount(){
	
	},
	mounted(){
    this.handleOrientationChange();
    window.addEventListener("orientationchange", this.handleOrientationChange)

    // if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    // 
    //     setTimeout(() => {
    //       this.fadeLoader()
    //     }, 2000);
    // } else {
    //   setTimeout(() => {
    //     document.addEventListener('DOMContentLoaded', this.fadeLoader())
    //   }, 2000);
    // }
    const vue = this;
    window.addEventListener('load', function () {
      setTimeout(() => {
        vue.fadeLoader()
      }, 2000);
    });
	},
	methods:{
    handleOrientationChange(){
      if(isMobile.deviceType != 'mobile') return false;
            
      setTimeout(() =>{
        let tablet_width = window.innerWidth;
        let tablet_height = window.innerHeight;
        if(tablet_width > tablet_height){
          this.blockLandscape = true;
          document.body.classList.add('pageBlock');
        }else{
            this.blockLandscape = false;
            document.body.classList.remove('pageBlock');
        }
        
      },100);
      
    },
		fadeLoader: function(){

			const self = this
			const tl = gsap.timeline()
			tl.to('.loading__left',{duration:1.2,x:"-100%"},"0.2")
      tl.to('.loading__right',{duration:1.2,x:"100%"},"0.2")
			tl.to('.loading__clap',{duration:0.7,delay:0,alpha:0},"0.2")
      tl.to('.loading__title',{duration:0.7,delay:0,y:100,alpha:0},"0.2")
			setTimeout(() => {
				self.init = false
				self.home = true
			},1000);
		},
		enterLoading: function(){
			const tl = gsap.timeline()
            tl.from('.loading',{duration:0.3,delay:0,height:0})
            tl.from('.loading__title',{alpha:0},"0.5")
            tl.to('.loading__title',{alpha:0},"5")
            tl.to('.loading',{duration:0.5,delay:0,height:0},"5.5")
		}
	},
  components: {
    BlockLandscape,
    Loading,
    Menu, 
    Home,
    Map, 
    Video,
    Share,
    Infographic,
    Footer
  }
}
</script>

<style lang="scss">
</style>
